import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// ⚠️ انسخ البيانات من Firebase Console (Web Config)
const firebaseConfig = {
  apiKey: "AIzaSyCLQwy-80xptQNjG0HcO-sSMddrgiKS3XM",
  authDomain: "bazar-marketplace-29dfe.firebaseapp.com",
  projectId: "bazar-marketplace-29dfe",
  storageBucket: "bazar-marketplace-29dfe.firebasestorage.app",
  messagingSenderId: "271158805436",
  appId: "1:271158805436:web:f0171d2be60eb9766461b9",
  measurementId: "G-N9JPNNVCZQ"
};
// ✅ initialize app
const app = initializeApp(firebaseConfig);

// Auth instance
export const auth = getAuth(app);
